import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Customer} from "../../../models/CustomerInfo/Customer";
import {AuthService} from "../../../../../services/auth.service";
import {RegistryService} from "../../../services/registry.service";
import {Router} from "@angular/router";

@Component({
    selector: 'app-customer-login',
    templateUrl: './customer-login.component.html',
    styleUrls: ['./customer-login.component.css']
})
export class CustomerLoginComponent implements OnInit {


    loginForm = new FormGroup({

        login_email: new FormControl('', Validators.required),
        login_password: new FormControl('', Validators.required),
    });

    customer: Customer;
    isLoggin = false;
    isLogginout = false;

    constructor(private authService: AuthService, private registry: RegistryService,
                private router:Router
                ) {
    }

    ngOnInit(): void {
    }


    login() {

        let email = this.loginForm.value.login_email;
        let password = this.loginForm.value.login_password;

        this.isLoggin = true;
        this.authService.customerAuthentication(email, password).subscribe(token => {

            //setup the user
            localStorage.setItem('customer_type', 'user');
            localStorage.setItem('t', String(token));

            this.registry.setupCustomer().subscribe(success => {

                    this.isLoggin = false;
                    this.router.navigateByUrl("/");
                },
                failure => {
                    this.isLoggin = false;
                }
            )

        },error =>{

        });


    }


}
